<template>
  <mw-dialog size="view" :width="params.width ? params.width : ''" :beforeClose="beforeClose" :height="params.height ? params.height : ''"   customClass="dialog__preView" :closeOnClickModal="true"  :appendToBody="false" ref="dialog" :title="params.title || '视图预览'">
    <mw-view :id="params.id" :params="params.params" :tableParams="params.tableParams" :oneMenuShowTab="false"></mw-view>
  </mw-dialog>
</template>
<script>

  export default {
    props:{
      params:{
        type: Object
      }
    },

    data() {
      let me = this;
      return {

      }
    },

    mounted(){
      setTimeout(()=>{
        this.show();
      },200)
    },

    methods: {
      beforeClose(done){
        if($.isFunction(this.params.secondfunc)){
          this.params.secondfunc()
        }
        done();
      },
      show(){
        this.mwRef('dialog').show();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/view-preview.vue